import { NeighborhoodSchoolsProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  NeighborhoodSchoolsProps["options"],
  OptionalPropertyOf<NeighborhoodSchoolsProps["options"]>
> = {
  hideAttribution: false,
};

export default defaultState;
